<template>
  <v-container class="ma-0 pa-0">
    <v-layout v-resize="onResize" column>
      <v-overlay class="d-flex d-md-none" :value="menuGuideOverlay">
        <div class="swipe">
          <v-btn icon dark @click="oncloseMenuGuide" class="swipe-close">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <img src="../assets/tableau/swipe.png" />
          <div class="swipe-desc">터치하여 메뉴를 움직여보세요</div>
        </div>
      </v-overlay>

      <div style="position:relative" class="ma-2 pa-2">
        <v-btn
          outlined
          color="error"
          class="mx-1 font-weight-bold"
          @click="clickFilterMode('핵심보기')"
        >핵심 차트 보기</v-btn>
        <v-btn
            outlined
            color="#8B7E74"
            class="mx-1 font-weight-bold"
            @click="clickFilterMode('인기있는')"
        >
          인기 차트 보기
        </v-btn>
        <v-btn
          outlined
          color="success"
          class="mx-1 font-weight-bold"
          @click="clickFullExtensionMode"
        >전체 차트 보기</v-btn>
        <div class="search">
          <input
            v-model="searchText"
            @keyup.enter="searchTextHandler"
            type="text"
            name="search"
            class="search-input"
            placeholder="부동산,유형,갭,갭투자,전세가,전세가율,전국,현황,new등 키워드입력"
            >
            <v-icon class="mr-1" @click=searchTextHandler>mdi-magnify</v-icon>
        </div>
      </div>

      <bjd-code-select-component bjdLevel="emd"/>

      <div
        id="tree-diagram"
        :style="{'overflow-x': 'scroll',
        'width': `${this.windowsSizeX}px`}"
      ></div>

      <v-footer v-if="tooltipMessage" dark paddless class="node-tooltip pa-0">
        <v-card flat tile class="flex grey darken-1 white--text text-center pa-5 pb-0">
          <v-card-text class="white--text pt-0 body-1">
            <div v-html="tooltipMessage"></div>
          </v-card-text>
        </v-card>
      </v-footer>
    </v-layout>
  </v-container>
</template>

<script>
import * as d3 from "d3";
import { mapState, mapMutations } from "vuex";
import { api } from '../mixins/api.js';
import BjdCodeSelectComponent from "./b2b/BjdCodeSelectComponent";

String.prototype.count = function(c) {
  var result = 0,
    i = 0;
  for (i; i < this.length; i++) if (this[i] === c) result++;
  return result;
};

const FONT_SIZE = 15;
const LEAF_NODE_FONT_SIZE = 15;
const BAR_WIDTH = 120;
const HEIGHT_MARGIN = 1.4;
const INITIAL_WIDTH = 1600;
const INITIAL_HEIGHT = 700;
const MENU_GUIDE_OVERLAY_LS = "menuGuideOverlay";

let i = 0;
function hangleCount(name) {
  let re = RegExp("[가-힣]");
  let count = 0;
  for (let i = 0; i < name.length; ++i) {
    count += re.test(name[i]) ? 1 : 0;
  }
  return count;
}

function getItemWidth(name) {
  const count = hangleCount(name);
  return (count * FONT_SIZE) + ((name.length + 1 - count ) * 3);
}

function isLeafNode(d) {
  return !("children" in d && d.children.length > 0);
}

function hasTag(d, tagName) {
  return "tags" in d && d.tags.includes(tagName);
}

function hasTag2(d, tagName) {
  return "tags" in d && d.tags.filter(x => x.includes(tagName)).length > 0;
}

function deleteNodes(d, deleteNodes) {
  for (let i = 0; i < deleteNodes.length; ++i) {
    for (let j = 0; j < d.children.length; ++j) {
      if (deleteNodes[i] === d.children[j].id) {
        d.children.splice(j, 1);
        break;
      }
    }
  }
}

function filterByTag(d, tagName) {
  // 마지막 노드인가
  if (isLeafNode(d)) {
    // 내가 삭제 대상인가?
    return !hasTag(d, tagName);
  } else {
    // 자식들을 순회한다.
    let nodes = [];
    for (let i = 0; i < d.children.length; ++i) {
      if (filterByTag(d.children[i], tagName)) {
        nodes.push(d.children[i].id);
      }
    }

    // 제거할 자식들이 있다면 제거한다.
    deleteNodes(d, nodes);

    // 자식이 모두 제거되었다면 본인도 부모에게 제거 요청을 한다.
    return d.children.length === 0;
  }
}

function filterByTag2(d, tagName) {
  // 마지막 노드인가
  if (isLeafNode(d)) {
    // 내가 삭제 대상인가?
    return !hasTag2(d, tagName);
  } else {
    // 자식들을 순회한다.
    let nodes = [];
    for (let i = 0; i < d.children.length; ++i) {
      if (filterByTag2(d.children[i], tagName)) {
        nodes.push(d.children[i].id);
      }
    }

    // 제거할 자식들이 있다면 제거한다.
    deleteNodes(d, nodes);

    // 자식이 모두 제거되었다면 본인도 부모에게 제거 요청을 한다.
    return d.children.length === 0;
  }
}

export default {
  components: {BjdCodeSelectComponent},
  props: {
    title: {
      type: String,
      default() {
        return "";
      }
    },
    name: {
      type: String,
      default() {
        return null;
      }
    }
  },
  async created() {
    this.menuData = await api.methods.getMenuApi(this.name);

    if (localStorage.getItem(MENU_GUIDE_OVERLAY_LS)) {
      this.menuGuideOverlay = false;
    }
    this.windowsSizeX = window.innerWidth;
  },
  data() {
    return {
      menuGuideOverlay: true,
      currentMenuData: null,
      margin: { top: 20, right: 90, bottom: 30, left: 90 },
      svg: null,
      root: null,
      duration: 500,
      treemap: null,
      tooltipMessage: null,
      windowsSizeX: 0,
      searchText: "",
      menuData: {
        type: Object,
        default() {
          return {};
        }
      },
      currentModeFunc: null,
      lastTagName: null,
      lastIsPerfectMatch: false
    };
  },
  computed: {
    ...mapState([
        "realestateD3Root",
        "economyD3Root",
        "selectedTableauId",
        "authorityLevel",
        "profile"
    ]),
    width() {
      return INITIAL_WIDTH;
    },
    height() {
      return INITIAL_HEIGHT;
    },
    isRealestate() {
      return this.name === "realestate";
    },
    isEconomy() {
      return this.name === "economy";
    }
  },
  mounted() {
    this.init();
    this.update(this.root);
    this.onResize();
  },
  beforeDestroy() {
    if (this.isRealestate) {
      this.$store.commit("setRealestateD3Root", this.root);
    } else {
      this.$store.commit("setEconomyD3Root", this.root);
    }
  },
  watch: {
    menuData: function() {
      this.clickCollapseDefaultMode();
      this.clickFilterMode('핵심보기')
    }
  },
  methods: {
    ...mapMutations(["showDrawer", "setSelectedTableauId"]),
    searchTextHandler() {
      if (this.searchText.length == 0) {
        return;
      }

      const count = this.getItemCount(this.menuData['children'], this.searchText);
      console.log('count', count)
      if (count == 0) {
        alert('결과가 없습니다.');
        return;
      }
      try {
        this.clickFilterMode(this.searchText, false);
      } catch (error) {
        // console.error(error)
      }
    },
    oncloseMenuGuide() {
      this.menuGuideOverlay = false;
      localStorage.setItem(MENU_GUIDE_OVERLAY_LS, true);
    },
    onResize() {
      this.windowsSizeX = window.innerWidth;
    },
    onNodeMouseOver(d) {
      this.tooltipMessage = d.data.desc;
    },
    onNodeMouseOut() {
      this.tooltipMessage = null;
    },
    clickCollapseDefaultMode() {
      this.$ga.event(
        this.isRealestate ? "부동산 리치고" : "경제 리치고",
        "메뉴 트리 클릭",
        "기본보기"
      );

      this.reloadRoot();
      this.collapseDefaultMode();
      this.resizeTreemap(this.width, this.calculateHeight());
      this.update(this.root);
      this.onResize();

      this.currentModeFunc = this.clickCollapseDefaultMode;
    },
    collapseDefaultMode() {
      if (this.isRealestate) {
        if (this.root.children) {
          for (let i = 0; i < this.root.children.length; ++i) {
            if (this.root.children[i].children) {
              this.root.children[i].children.forEach(this.collapse);
            }
          }
        }
      }
    },
    clickFullExtensionMode() {
      this.$ga.event(
        this.isRealestate ? "부동산 리치고" : "경제 리치고",
        "메뉴 트리 클릭",
        "펼쳐보기"
      );

      this.reloadRoot();
      this.click(this.root);
      this.click(this.root);
      this.update(this.root);
      this.onResize();

      this.currentModeFunc = this.clickFullExtensionMode;
    },
    clickFilterMode(tagName, isPerfectMatch=true) {

      this.$ga.event(
          this.isRealestate ? "부동산 리치고" : "경제 리치고",
          "메뉴 트리 클릭",
          tagName
        );

      this.resizeTreemap(this.width, this.calculateHeight());
      this.setCurrentMenuData(JSON.parse(JSON.stringify(this.menuData)));
      if (isPerfectMatch) {
        filterByTag(this.currentMenuData, tagName);
      } else {
        filterByTag2(this.currentMenuData, tagName);
      }

      this.initRoot();

      this.click(this.root);
      this.click(this.root);
      this.update(this.root);
      this.onResize();

      this.lastTagName = tagName;
      this.lastIsPerfectMatch = isPerfectMatch;
      this.currentModeFunc = this.clickFilterMode;
    },
    getItemCount(items, tagName) {
      let totalCount = 0;

      items.forEach(v => {
        if (Object.keys(v).includes('children')) {
          // 자식이 있다.
          totalCount += this.getItemCount(v['children'], tagName)
        }

        let count = 0;
        if (Object.keys(v).includes('tags')) {
          v['tags'].forEach(tag => {
            if (tag.includes(tagName)) {
              count += 1;
              }
          })
        }
        totalCount += count;
      })
      return totalCount;
    },
    calculateHeight() {
      const height = INITIAL_HEIGHT + this.leafNodeCount() * 40;
      return height <= INITIAL_HEIGHT ? INITIAL_HEIGHT : height;
    },
    leafNodeCount() {
      if (!this.treemap) return 0;

      var treeData = this.treemap(this.root);
      var nodes = treeData.descendants();

      return nodes.filter(function(d) {
        return !(d._children || d.children);
      }).length;
    },
    resizeTreemap(width, height) {
      d3.select("svg")
        .attr("width", width)
        .attr(
          "height",
          height > window.innerHeight ? height : window.innerHeight
        );

      this.treemap = d3.tree().size([height, width]);
    },
    initRoot() {
      this.root = d3.hierarchy(this.currentMenuData, function(d) {
        return d.children;
      });
      this.root.x0 = INITIAL_HEIGHT / 2;
      this.root.y0 = 0;
    },
    reloadRoot() {
      this.setCurrentMenuData(JSON.parse(JSON.stringify(this.menuData)));
      this.initRoot();
      this.resizeTreemap(this.width, this.calculateHeight());
    },
    setCurrentMenuData(v) {
      this.currentMenuData = v;
    },
    init() {
      this.svg = d3
        .select("#tree-diagram")
        .append("svg")
        .append("g")
        .attr(
          "transform",
          "translate(" + this.margin.left + "," + this.margin.top + ")"
        );

      d3.select("svg")
        .attr("width", this.width)
        .attr("height", this.height);

      this.treemap = d3.tree().size([this.height, this.width]);

      // loadRoot
      if (this.isRealestate && this.realestateD3Root) {
        this.root = this.realestateD3Root;
        this.resizeTreemap(this.width, this.calculateHeight());
      } else if (this.isEconomy && this.economyD3Root) {
        this.root = this.economyD3Root;
        this.resizeTreemap(this.width, this.calculateHeight());
      } else {
        this.clickCollapseDefaultMode();
      }
    },
    collapse(d) {
      if (d.children) {
        d._children = d.children;
        d._children.forEach(this.collapse);
        d.children = null;
      }
    },
    click(d) {
      if (d.children) {
        d._children = d.children;
        d.children = null;
      } else if (d._children) {
        d.children = d._children;
        d._children = null;
      } else {
        if (this.name === null) {
          alert("플랫폼 이름이 없습니다.");
          return;
        }

        if (this.authorityLevel < (d.data.authorityLevel || 0)) {
          let userLevelName = "미결제유저"
          if (this.authorityLevel === 100) userLevelName = '일반';
          if (this.authorityLevel === 200) userLevelName = '고급';
          if (this.authorityLevel === 300) userLevelName = '프리미엄';

          let levelName = "";
          if ((d.data.authorityLevel || 0) === 100) levelName = '일반';
          if ((d.data.authorityLevel || 0) === 200) levelName = '고급';
          if ((d.data.authorityLevel || 0) === 300) levelName = '프리미엄';

          alert(`이 메뉴는 ${levelName} 등급 이상 사용 가능합니다.\n고객님의 등급은 ${userLevelName}입니다.\n\n등급: 일반 < 고급 < 프리미엄`)
          return;

        }
        this.setSelectedTableauId(d.data.id);
        this.update(d);

        // 마지막 함수 다시 콜 해주면서 색상 업데이트 해주기
        if (this.currentModeFunc) {
          this.currentModeFunc(this.lastTagName, this.lastIsPerfectMatch);
        }

        this.showDrawer(false);

        this.$router.push({
          // paht: this.name,
          params: { tableauId: d.data.url }
        });
        return;
      }

      this.resizeTreemap(this.width, this.calculateHeight());
      this.update(d);
    },
    clickYoutube(d) {
      window.open(d.data.guideUrl);
    },
    update(source) {
      let widthScale = d3
        .scaleLinear()
        .domain([1, 80])
        .range([1, 80]);

      // Assigns the x and y position for the nodes
      var treeData = this.treemap(this.root);

      // Compute the new tree layout.
      var nodes = treeData.descendants(),
        links = treeData.descendants().slice(1);

      // Normalize for fixed-depth.
      nodes.forEach(function(d) {
        d.y = d.depth * 250;
      });

      // ****************** Nodes section ***************************

      // Update the nodes...
      var node = this.svg.selectAll("g.node").data(nodes, function(d) {
        return d.id || (d.id = ++i);
      });

      // Enter any new modes at the parent's previous position.
      var nodeEnter = node
        .enter()
        .append("g")
        .attr("class", "node")
        .attr("transform", function() {
          return (
            "translate(" +
            (source.y0 + 120) +
            "," +
            source.x0 / HEIGHT_MARGIN +
            ")"
          );
        })
        .attr("cursor", "pointer")
        .on("click", this.click);

      // Add Rectangle for the nodes
      // 자식이 있는 노드
      nodeEnter
        .filter(function(d) {
          return d._children || d.children;
        })
        .append("rect")
        .attr("class", "node")
        .attr("x", 5)
        .attr("y", -3)
        .attr("width", BAR_WIDTH)
        .attr("height", 5)
        .attr("rx", 3)
        .attr("ry", 3)
        .style("fill", function(d) {
          return d.data.barColor || "#000000";
        })
        .style("stroke", function(d) {
          return d.data.barColor || "#000000";
        });

      // Add Circle for the nodes
      nodeEnter
        .filter(function(d) {
          return "children" in d.data;
        })
        .append("circle")
        .attr("class", "node")
        .attr("cx", BAR_WIDTH + 20)
        .attr("r", 5)
        .style("fill", function(d) {
          return d._children ? d.data.barColor || "#000000" : "#fff";
        })
        .style("stroke", function(d) {
          return d.data.barColor || "#000000";
        });

      // Add labels for the nodes
      nodeEnter
        .filter(function(d) {
          return "children" in d.data;
        })
        .append("text")
        .attr("class", "node")
        .attr("font-weight", "bold")
        .attr("x", function(d) {
          return 70 - getItemWidth(d.data.name) / 2;
        })
        .attr("y", 23)
        .text(function(d) {
          return d.data.name;
        })
        .style("font-size", FONT_SIZE + "px")
        .style("fill", function(d) {
          return d.data.fontColor || "#000000";
        });

      const selectedTableauId = this.selectedTableauId;
      nodeEnter
        .filter(function(d) {
          return !(d._children || d.children);
        })
        .append("text")
        .attr("class", "node")
        .attr("font-weight", function(d) {
          return selectedTableauId === d.data.id ? 700 : 'bold';
        })
        .attr("x", 7 + 20) // 기본 아이콘 사이즈
        .attr("y", 5)
        .text(function(d) {
          return d.data.name;
        })
          // .style("color", "red")
        .style("font-size", LEAF_NODE_FONT_SIZE)
        .style("fill", function(d) {
          return selectedTableauId === d.data.id ? '#F5A21E' : d.data.fontColor;
          // return d.data.fontColor || "#000000";
        })
        .attr("id", function(d) {
          return d.data.id;
        });

      nodeEnter
        .filter(function(d) {
          return "icon" in d.data;
        })
        .append("image")
        .attr("class", "node")
        .attr("xlink:href", function(d) {
          return require(`../../public/icons/${d.data.icon}.png`);
        })
        .attr("width", "24")
        .attr("x", 70 - 12)
        .attr("y", -29);

      nodeEnter
        .filter(function(d) {
          return "guideUrl" in d.data && d.data.guideUrl.length > 0;
        })
        .append("image")
        .attr("class", "node")
        .attr("xlink:href", function() {
          return require(`../../public/icons/document.png`);
        })
        .attr("width", 24)
        .attr("x", function () {
          this.parentNode.getBoundingClientRect().width
          // 220503 sunhye this 바인딩 image로
        })
        .attr("y", -13)
        .on("click", this.clickYoutube);


      // 권한 레벨에 따른 작업
      let authNodes = nodeEnter
          .filter(function(d) {
            return "authorityLevel" in d.data
                && d.data.url
                && (d.data.authorityLevel === 100 || d.data.authorityLevel === 200 || d.data.authorityLevel === 300);
          });

      authNodes
          .append("image")
          .attr("class", "node")
          .attr("xlink:href", function(d) {
            if (d.data.authorityLevel === 100) {
              return require(`../../public/icons/level/basic.png`);
            } else if (d.data.authorityLevel === 200) {
              return require(`../../public/icons/level/advanced.png`);
            } else if (d.data.authorityLevel === 300) {
              return require(`../../public/icons/level/premium.png`);
            }
          })
          .attr("width", 25)
          .attr("x", 0)
          .attr("y", -10);




      // UPDATE
      var nodeUpdate = nodeEnter.merge(node);

      // Transition to the proper position for the node
      nodeUpdate
        .transition()
        .duration(this.duration)
        .attr("transform", function(d) {
          return "translate(" + d.y + "," + d.x / HEIGHT_MARGIN + ")";
        });

      nodeUpdate.select("circle.node").style("fill", function(d) {
        return d._children ? d.data.barColor || "#000000" : "#fff";
      });


      // Remove any exiting nodes
      var nodeExit = node
        .exit()
        .transition()
        .duration(this.duration)
        .attr("transform", function() {
          return (
            "translate(" +
            (source.y + 120) +
            "," +
            source.x / HEIGHT_MARGIN +
            ")"
          );
        })
        .remove();

      nodeExit
        .select("rect")
        .attr("x", 0)
        .attr("y", 0)
        .attr("width", 0)
        .attr("height", 0);

      nodeExit.select("text").style("fill-opacity", 1e-6);

      nodeExit.select("circle.node").attr("cx", 0);

      // ****************** links section ***************************

      // Update the links...
      var link = this.svg
        .selectAll("path.link")
        .data(links, function(d) {
          return d.id;
        })
        .style("stroke-width", function(d) {
          return widthScale(d.data.value);
        });

      // Enter any new links at the parent's previous position.
      var linkEnter = link
        .enter()
        .insert("path", "g")
        .attr("class", "link")
        .attr("d", function() {
          var o = { x: source.x0 / HEIGHT_MARGIN, y: source.y0 + 140 };
          return diagonal(o, o);
        });

      // UPDATE
      var linkUpdate = linkEnter.merge(link);

      // Transition back to the parent element position
      linkUpdate
        .transition()
        .duration(this.duration)
        .attr("d", function(d) {
          var o = { x: d.x / HEIGHT_MARGIN, y: d.y };
          var p = { x: d.parent.x / HEIGHT_MARGIN, y: d.parent.y + 140 };
          return diagonal(o, p);
        });

      // Remove any exiting links
      link
        .exit()
        .transition()
        .duration(this.duration)
        .attr("d", function() {
          var o = { x: source.x / HEIGHT_MARGIN, y: source.y + 120 };
          return diagonal(o, o);
        })
        .style("stroke-width", function(d) {
          return widthScale(d.data.value);
        })
        .remove();

      // Store the old positions for transition.
      nodes.forEach(function(d) {
        d.x0 = d.x;
        d.y0 = d.y;
      });

      nodeEnter.on("mouseover", this.onNodeMouseOver);
      nodeEnter.on("mouseout", this.onNodeMouseOut);

      function diagonal(s, d) {
        // Creates a curved (diagonal) path from parent to the child nodes
        let path = `M ${s.y} ${s.x} L ${d.y} ${d.x}`;
        return path;
      }
    }
  }
};
</script>

<style>
.swipe {
  text-align: center;
  position: relative;
}

.swipe-close {
  position: absolute;
  top: -20%;
  left: -10%;
}

.swipe-desc {
  width: 100%;
}

.node circle {
  fill: red;
  /*   stroke: steelblue; */
  stroke-width: 3px;
}

.node rect {
  fill: #fff;
  stroke-width: 1px;
}

.link {
  fill: none;
  stroke: #ccc;
  /*   stroke-width: 2px; */
}

text.node {
  border: 5px solid red;
}

.node image {
  /*-webkit-filter: opacity(0.5) drop-shadow(0 0 0 black);*/
  /*filter: opacity(0.5) drop-shadow(0 0 0 black);*/
}


.node-tooltip {
  display: block;
  position: absolute;
  top: 0;
  width: 100%;
}

.search {
  display: inline-block;
  text-align: center;
  border: 1.5px solid gray;
  border-radius: 5px;

}

.search-input {
    width: 400px;

  height: 33px;
  padding: 0 10px;
  font-size: 14px;
}

.search-input::placeholder {
  text-align: center;
  font-size: 12px;
}

input:focus,
select:focus,
textarea:focus,
button:focus {
    outline: none;
}
</style>
